import https from "./https-common";

const getAllGroup = (shopDomain) => {
  let shop = shopDomain.replace(".myshopify.com", "");
  shop = shop.replace("https://", "");
  return https.get(`/groups?shop=${shop}`);
};

const getGroupById = (id) => {
  return https.get(`/group/${id}`);
};

const GroupService = {
  getAllGroup,
  getGroupById,
};

export default GroupService;
